/*
 * Copyright (c) 2024-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

class Subscription {
    constructor() {

        this.subscriptions = []
    }

    /**
     *
     * @param callback
     * @param name
     * @returns {Promise<any>}
     */
    async add(callback, name) {
        if (callback !== undefined) {
            let result = await callback()

            // handel callbacks that are directly returned like redux unsubscribing
            if (typeof result === 'function') {
                return [null, {cancel: result}]
            }

            if (typeof result?.[1] === 'function') {
                return [result[0], {cancel: result[1]}]
            }

            if (Array.isArray(result) && result.length === 2) {
                if (name !== undefined) {
                    let existingSubsciption = this.subscriptions.find(item => (item.name === name))
                    if (existingSubsciption !== undefined) {
                        existingSubsciption.sub.cancel()
                        this.subscriptions = this.subscriptions.filter(item => (item !== existingSubsciption))
                    }

                    this.subscriptions.push({sub: result[1], name: name})

                } else {
                    this.subscriptions.push({sub: result[1]})
                }
                return result[0]
            }

            if (typeof result?.cancel === 'function') {
                return [result, result]
            }

            return result

        }
    }

    unmount() {
        this.subscriptions.forEach((subscription) => {
            subscription.sub.cancel()
        })
    }

}

export {Subscription}